module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.ready) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-666a5fc6!./~/vue-loader/lib/selector.js?type=template&index=0!./Vue2LeafletGoogleMutant.vue
// module id = 3
// module chunks = 0